// Boiler Plate Imports
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  remove as removeNotification,
  add as addNotification,
} from "../../redux-store/notificationsSlice";
import { update as setBreadCrumbs } from "../../redux-store/breadCrumbsSlice";
import API from "../../api";
import colors from "../../theme/colors";
import { FullPageFormWrapper } from "../../components/Forms/shared";

// Conatiner Component Imports
import BreadCrumbs from "../../components/Navigation/breadcrumbs";
import ModalComponent from "../../components/Modal";

// Page Component Imports
import AdminNetworkForm from "../../components/Forms/adminNetworkForm";
import { useNavigate, useParams } from "react-router-dom";
import ConfirmForm from "../../components/Forms/confirmForm";
import { NoChartDataPlaceholder } from "../../components/NoDataPlaceholder";
import { CircularProgress } from "@mui/material";
import { FormatPhoneNumber } from "../../components/PhoneNumberInput";

const EditNetwork = () => {
  const userProfile = useSelector((state) => state.user);
  const organization = useSelector((state) => state.organization);
  const { networkId } = useParams();

  const [network, setNetwork] = useState({});

  const [saving, setSaving] = useState(false);
  const [savingError, setSavingError] = useState(false);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [organizationsList, setOrganizationsList] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dataLayer.GetAllOrganizations();
    dataLayer.GetNetwork();
  }, []);

  useEffect(() => {
    //Set Bread Crumbs
    dispatch(
      setBreadCrumbs([
        {
          title: "Admin Networks",
          link: "/admin/networks",
        },
        {
          title: "Edit Network",
          link: `/admin/networks/${networkId}/edit`,
        },
      ])
    );
  }, []);

  const dataLayer = {
    GetAllOrganizations: async () => {
      const { organizations } = await API.Organization.OrganizationsGetAll();
      setOrganizationsList(organizations);
    },
    GetNetwork: async () => {
      const { network: _network, metrics: _metrics } =
        await API.Network.NetworkGet({ networkId });
      _network.users.forEach((user) => {
        user.status = (() => {
          if (user.deleted) {
            return "Deactivated";
          } else if (user.invitePending) {
            return "Invite Pending";
          } else {
            return "Active";
          }
        })();
        user.dateCreateObject = new Date(user.created);
        user.phoneString = FormatPhoneNumber(user.phone);
      });
      setNetwork(_network);
    },
    UpdateNetwork: async ({ updateNetworkBodyData }) => {
      const res = await API.Network.NetworkUpdate({
        updateNetworkBodyData,
      });
    },
  };

  const handlers = {
    confirmModalSubmit: () => {
      navigate(`/admin/networks/${networkId}`);
    },
    confirmModalCancel: () => {
      setShowConfirmModal(false);
    },
    cancel: () => {
      setShowConfirmModal(true);
    },
    saveNetwork: async ({ name, organizationIds }) => {
      setSavingError("");
      setSaving(true);
      try {
        await dataLayer.UpdateNetwork({
          updateNetworkBodyData: {
            networkId,
            name,
            organizationIds,
          },
        });

        //Create Success Notification
        const id = new Date().getTime();
        dispatch(
          addNotification({
            id,
            severity: "success",
            title: "Success",
            message: "Network updated successfully",
          })
        );
        setTimeout(() => {
          dispatch(removeNotification(id));
        }, 3000);
        navigate(`/admin/networks/${networkId}`);
      } catch (err) {
        let errorMessage = err;
        setSavingError(errorMessage);
        console.log(err);
        const id = new Date().getTime();
        dispatch(
          addNotification({
            id,
            severity: "error",
            title: "Error Updating Network",
            message: errorMessage,
          })
        );
        setTimeout(() => {
          dispatch(removeNotification(id));
        }, 3000);
      }
      setSaving(false);
    },
  };

  return (
    <>
      
      <FullPageFormWrapper>
        <h2>
          Edit Network{" "}
          <span style={{ color: colors.gray }}> / Boreas Admin</span>
        </h2>
        {organizationsList.length && network?.name ? (
          <AdminNetworkForm
            handleSave={handlers.saveNetwork}
            handleCancel={handlers.cancel}
            saving={saving}
            error={savingError}
            organizationsList={organizationsList}
            network={network}
            users={network.users}
            isEdit={true}
          />
        ) : (
          <CircularProgress />
        )}
      </FullPageFormWrapper>
      <ModalComponent
        open={showConfirmModal}
        handleClose={handlers.confirmModalCancel}
        headerText={"Cancel Editing Network"}
      >
        <ConfirmForm
          handleSave={handlers.confirmModalSubmit}
          handleCancel={handlers.confirmModalCancel}
          loading={false}
        >
          <div>
            <b>Are you sure you want to Cancel Editing this Network?</b>
            <p>You will lose all progress.</p>
          </div>
        </ConfirmForm>
      </ModalComponent>
    </>
  );
};

export default EditNetwork;
